module.exports = __webpack_public_path__ + "static/20-07f2e1387667c459c0fc661d80f1ade8.png";